import type { AuthSession } from "../types/supplier";

const ACCESS_KEY = "kithub.supplier.accessToken";
const REFRESH_KEY = "kithub.supplier.refreshToken";

export const sessionStore = {
  load(): AuthSession | null {
    const accessToken = localStorage.getItem(ACCESS_KEY);
    const refreshToken = localStorage.getItem(REFRESH_KEY);
    return accessToken && refreshToken ? { accessToken, refreshToken } : null;
  },

  save(session: AuthSession) {
    localStorage.setItem(ACCESS_KEY, session.accessToken);
    localStorage.setItem(REFRESH_KEY, session.refreshToken);
  },

  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};
